import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import './GiftCardImage.scss';

// A URL built from an empty logo field ends in "/", "/null" or "/undefined"
const isMissing = (src) => !src || /\/(null|undefined)?$/.test(String(src));

// Merchant gift card art. When the merchant has no image or it fails to load, shows a
// neutral placeholder: a gift icon plus the merchant name ("Gift Code" if unnamed).
// The placeholder fills whatever frame the caller sizes, so it drops into any logo slot.
const GiftCardImage = ({ src, name, alt, className, ...imgProps }) => {
    const { t } = useTranslation();
    const [failed, setFailed] = useState(false);

    useEffect(() => { setFailed(false); }, [src]);

    if (isMissing(src) || failed) {
        return (
            <div className="giftcard-placeholder" role="img" aria-label={alt || name || 'Gift card'}>
                <CardGiftcardIcon className="giftcard-placeholder__icon" />
                <span className="giftcard-placeholder__name">{name || t('gift_code')}</span>
            </div>
        );
    }

    return (
        <img
            {...imgProps}
            className={className}
            src={src}
            alt={alt ?? name}
            onError={() => setFailed(true)}
        />
    );
};

GiftCardImage.propTypes = {
    src: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
};

GiftCardImage.defaultProps = {
    src: '',
    name: '',
    alt: undefined,
    className: undefined,
};

export default GiftCardImage;
